import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { documentLocalization } from 'document/model/document.fragments';
import { SaveDocumentInput } from 'document/mutation/save-document.mutation';
import { userModuleAnswerQuestion } from 'module/model/page/question/module-question.fragments';
import { UserModuleAnswerType } from 'user/model/module/answer/user-module-answer.type';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { UserModuleAnswerOutput } from '../model/user-module-answer.output';

export interface UserModuleAnswersTaskInput {
	readonly dueTimestamp: number;
	readonly userTaskId: string;
	readonly done: boolean;
	readonly id: string;
}

export interface UserModuleAnswersAnswerInput {
	readonly saveDocumentInput: SaveDocumentInput;
	readonly taskInput: UserModuleAnswersTaskInput;
	readonly type: UserModuleAnswerType;
	readonly questionId: string;
	readonly articleId: string;
	readonly locale: string;
	readonly pageId: string;
	readonly value: string;
}

export interface SaveUserModuleAnswersInput {
	readonly answers: UserModuleAnswersAnswerInput[];
	readonly graphs: { [key: string]: string };
	readonly reportJobOfferId: string;
	readonly reportTaskId: string;
	readonly isAutoSave: boolean;
	readonly contactId: string;
	readonly moduleId: string;
	readonly userId: string;
}

export interface SaveUserModuleAnswersParams {
	readonly input: SaveUserModuleAnswersInput;
}

@Injectable({ providedIn: 'root' })
export class SaveUserModuleAnswersApiMutation extends ApiMutation<
	UserModuleAnswerOutput[],
	SaveUserModuleAnswersParams
> {
	client = 'content';
	document = gql`
		mutation SaveUserModuleAnswers($input: SaveUserModuleAnswersInput!) {
			saveUserModuleAnswers(input: $input) {
				id
				type
				value
				pageId
				userId
				moduleId
				contactId
				orgModuleId
				reportTaskId
				reportJobOfferId
				updateTimestamp
				article {
					id
				}
				task {
					id
					label
					userTaskId
					dueTimestamp
				}
				question {
					...UserModuleAnswerQuestion
				}
				document {
					id
					type
					updateTimestamp
					localizations {
						...DocumentLocalization
					}
					lastOpenTimestamp
					creationTimestamp
				}
			}
		}
		${documentLocalization}
		${userModuleAnswerQuestion}
	`;
	method = 'saveUserModuleAnswers';
}
